<template>
    <div>
        <div class="app-container">
      
            <div class="swiper">
                <swiper
                    ref="mySwiper"
                    :options="swiperOptions"
                    v-if="data.annualReportHome || data.reportHomeData"
                    :key="index"
                >
                    <swiper-slide >
                        <index :data="data.annualReportHome" v-if="$route.query.type != 'epic'"></index>
                        <index :data="data.reportHomeData" v-if="$route.query.type == 'epic'"></index>
                    </swiper-slide>

                  

                    <swiper-slide >
                        <gamePrice
                            :data="data.gameAllPrice"
                            v-if="$route.query.type == 'steam' || $route.query.type == 'psn'"
                        ></gamePrice>
                        <gamePrice :data="data.freeGamePricePageData" v-if="$route.query.type == 'epic'"></gamePrice>
                        <gamePrice
                            :data="data.achievementPointsPage"
                            v-if="$route.query.type == 'xbox'"
                        ></gamePrice>
                    </swiper-slide>
                      <swiper-slide v-if="$route.query.type != 'xbox'" >
                        <gameTime :data="data.yearPlayGameTimePage" v-if="$route.query.type != 'epic'"></gameTime>
                        <gameTime :data="data.freeGameTimePageData" v-if="$route.query.type == 'epic'"></gameTime>
                    </swiper-slide>

                    <swiper-slide
                        v-if="$route.query.type != 'epic' && data.likeBestPage.gameName != null"
                    >
                        <likeGame :data="data.likeBestPage"></likeGame>
                    </swiper-slide>
                    <swiper-slide
                        v-if="$route.query.type == 'epic' && data.isShowYearMostFreePage"
                    >
                        <dearGame :data="data.yearMostFreePageData"></dearGame>
                    </swiper-slide>

                    <swiper-slide
                        v-if="$route.query.type == 'epic' && data.isShowYearHotGamePage"
                    >
                        <likeGame :data="data.yearHotGamePageData"></likeGame>
                    </swiper-slide>
                    <swiper-slide
                        v-if="
                            $route.query.type != 'xbox' &&
                            $route.query.type != 'epic' &&
                            data.yearRechargeGamePage.gameName != null
                        "
                    >
                        <dearGame :data="data.yearRechargeGamePage"></dearGame>
                    </swiper-slide>
                    
                      <swiper-slide
                        v-if="
                            // ($route.query.type == 'steam' || $route.query.type == 'psn') &&
                             $route.query.type == 'psn' &&
                            data.yearNewGamePage.gameName != null
                        "
                    >
                        <longTimeGame :data="data.yearNewGamePage"></longTimeGame>
                    </swiper-slide>
                     <swiper-slide
                        v-if="
                            $route.query.type == 'steam' &&
                            data.stayUpLatePlayGamePage.gameName != null
                        "
                    >
                        <playLateGame :data="data.stayUpLatePlayGamePage"></playLateGame>
                    </swiper-slide>
                    
                    <swiper-slide v-if="$route.query.type != 'epic' && data.yearHotGamePage.gameName != null" >
                        <hotGame :data="data.yearHotGamePage"></hotGame>
                    </swiper-slide>


                    <swiper-slide
                        v-if="
                            $route.query.type != 'epic' &&
                            $route.query.type != 'xbox' &&
                            data.yearAccompanyNewGamePage.gameName != null
                        "
                    >
                        <highScoreGame :data="data.yearAccompanyNewGamePage"></highScoreGame>
                    </swiper-slide>

                    <swiper-slide
                        v-if="
                            $route.query.type != 'epic' &&
                            $route.query.type == 'xbox' &&
                            data.yearHighScoreNewGamePage.gameName != null
                        "
                    >
                        <highScoreGame :data="data.yearHighScoreNewGamePage"></highScoreGame>
                    </swiper-slide>


                     <swiper-slide v-if="$route.query.type != 'epic' && data.bestDifferentPage.gameName != null" >
                        <differentGame :data="data.bestDifferentPage"></differentGame>
                    </swiper-slide>

                    <swiper-slide v-if="$route.query.type != 'epic'" >
                        <share :data="data.sharePage" :achievementPoints='data.annualReportHome.yearAchievementPoints'></share>
                    </swiper-slide>

                    <swiper-slide v-if="$route.query.type == 'epic'" :class="{ 'noSwipingClass': noSwiping }">
                        <gameList :data="data.freeGameListPageData"></gameList>
                    </swiper-slide>
                </swiper>
            </div>
            <transition name="fade">
            <div class="btn" v-if="shareBtn && $route.query.type != 'epic' " :style="shareBoxBg" >
                <div class="saveBtn" @click="save()">
                    <div class="icon" :style="borderSty">
                        <div :style="iconbgSty"><img src="../assets/image/steam/xiazai.png" alt="" /></div>
                    </div>
                    <div class="btnTxt">保存图片</div>
                </div>
                <div class="shareBtn" @click="save()">
                    <div class="icon" :style="borderSty">
                        <div :style="iconbgSty"><img src="../assets/image/steam/zhuanfa.png" alt="" /></div>
                    </div>
                    <div class="btnTxt">分享年报</div>
                </div>
            </div>
          </transition>
        </div>
        <div class="epicShareBtn" v-if="$route.query.type == 'epic' && !$route.query.shareRef" @click="epicShare">
            <div>分享我的EPIC年度总结！</div>
        </div>
        <div class="epicShareBtn" v-if="$route.query.type == 'epic' && $route.query.shareRef" @click="epicDownBtn">
            <div>查看我的EPIC年度总结</div>
        </div>
        
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

import footerPage from './footer.vue' 
import footerBg from './footerBg.vue'
import headerBg from './headerBg.vue'

import "swiper/dist/css/swiper.css";

import index from "./index";
import gameTime from "./gameTime";
import gamePrice from "./gamePrice";
import likeGame from "../views/report/likeGame";
import highScoreGame from "../views/report/highScoreGame";
import playLateGame from "../views/report/playLateGame";
import differentGame from "../views/report/differentGame";
import dearGame from "../views/report/dearGame";
import hotGame from "../views/report/hotGame";
import longTimeGame from "../views/report/longTimeGame";
import share from "../views/report/share";
import waitingPage from "../views/report/waitingPage";
import percentage from "../views/report/percentage";
import gameList from "../views/report/gameList";

import report from "../api/index.js";
export default {
    data() {
        let that=this;
        return {
            index: 0,
            slideIndex: null,
            borderSty:{},
            iconbgSty:{},
            shareBoxBg:{},
            Original: "",
            swiperOptions: {
                slidesPerView: 1,
                speed: 1000,
                direction: "vertical",
                effect: "fade",
                height: 844,
                slidesPerView: "auto",
                fadeEffect: {
                    crossFade: true
                },
                noSwiping: true,
                noSwipingClass: "noSwipingClass",
                mousewheel: true,

                on: {
                    resize: function () {
                        this.update();
                    },
                    beforeDestroy: function () {
                        // window.localStorage.setItem("slideIndex", this.activeIndex);
                    },
                   
                    slideChange: function (e) {
                         window.localStorage.setItem("slideIndex", this.activeIndex);
                        let swiperLength = document.getElementsByClassName("swiper-slide").length;
                        if (
                            this.activeIndex == document.getElementsByClassName("swiper-slide").length - 1 &&
                            document.getElementsByClassName("epicShareBtn").length == 1
                        ) {
                            document.getElementsByClassName('swiper')[0].style.height='auto'
                            document.getElementsByClassName('swiper')[0].style.overflow='visible'
                            document.getElementsByClassName('swiper-container')[0].style.overflow='visible'
                            document.getElementsByClassName("epicShareBtn")[0].style.display = "block";

                            // document.getElementsByClassName("swiper-slide")[swiperLength - 1].style.overflow = "auto";
                        } else {
                            document.getElementsByClassName('swiper')[0].style.height='42.2rem'
                            document.getElementsByClassName('swiper')[0].style.overflow='hidden'
                            document.getElementsByClassName('swiper-container')[0].style.overflow='hidden'
                            // document.getElementsByClassName("swiper-slide")[swiperLength - 1].style.overflow =
                            //     "visible";
                            document.getElementsByClassName("epicShareBtn").length > 0
                                ? (document.getElementsByClassName("epicShareBtn")[0].style.display = "none")
                                : "";
                        }

                        
                        if (this.activeIndex!=document.getElementsByClassName("swiper-slide").length - 1 && that.$route.query.type!='epic') {
                            
                            that.shareBtn=false

                            document.getElementsByClassName('erweima')[0].style.opacity=0
                        }   


                        setTimeout(() => {
                            let title = ''
                            // if(this.activeIndex==document.getElementsByClassName("swiper-slide").length - 1 && that.$route.query.type!='epic'){
                            //     title='分享页'
                            // }else{
                               
                            // }
                           
                            title=document.querySelector('.swiper-slide-active .title').textContent
                            
                            if (that.$route.query.type == "steam") {
                                GSAppJsApi.UMeng.recordEvent('enter_steam_annual_report_success', `steam年报-${title}`);
                                GSAppJsApi.EventStatistics.recordEvent('B19104_成功进入steam年报的用户数', `steam年报-${title}`, 0);
                                
                            } else if (that.$route.query.type == "psn") {
                                GSAppJsApi.UMeng.recordEvent('enter_psn_annual_report_success', `psn年报-${title}`);
                                GSAppJsApi.EventStatistics.recordEvent('B19105_成功进入psn年报的用户数', `psn年报-${title}`, 0);
                                
                            } else if (that.$route.query.type == "xbox") {
                                GSAppJsApi.UMeng.recordEvent('enter_xbox_annual_report_success', `xbox年报-${title}`);
                                GSAppJsApi.EventStatistics.recordEvent('B19106_成功进入xbox年报的用户数', `xbox年报-${title}`, 0);
                                 console.log(`xbox年报-${title}`);
                            } else if (that.$route.query.type == "epic") {                     
                                GSAppJsApi.UMeng.recordEvent('enter_epic_annual_report_success', `epic年报-${title}`);
                                GSAppJsApi.EventStatistics.recordEvent('B19107_成功进入epic年报的用户数', `epic年报-${title}`, 0);
                               
                            }
                        }, 100);
                       
                    },
                    reachEnd(){
                        that.shareBtn=true
                    }
                    
                }
            },
            userId:GSAppJsApi.User.getCurrentUserId(),

            footerBg:{
                

            },
            headerBg:{
                
            },
            noSwiping: true,
            data: {},
            screeWidth: null,
            scrollTop: 0,
            touchStart: 0,
            sync: false,
            titles: [
                
            ],

            swiperIndex:0,
            shareBtn:false,

            clickShareBtn:true,
        };
    },

    created() {
        window.localStorage.removeItem("slideIndex");

        
    },
    mounted() {
      
        // window.localStorage.setItem("slideIndex", 0);
        if (this.$route.query.type == "steam") {
            document.body.style.background = "#0B1E23";
            this.borderSty.border = "0.05rem solid rgba(48,144,162,0.4)";
             this.iconbgSty.background = "#1A515C";
             this.shareBoxBg.backgroundColor="#0B1E23",
             this.shareBoxBg.top="35rem",
             
             
            this.getSteamData();
        } else if (this.$route.query.type == "psn") {
            document.body.style.background = "#0E172C";
            this.borderSty.border = "0.05rem solid #5EA6FF";
                this.iconbgSty.background = "#4B8BDB";
                 this.shareBoxBg.backgroundColor="#0E172C",
                 this.shareBoxBg.top="35rem",
            this.getPsnData();
        } else if (this.$route.query.type == "xbox") {
            document.body.style.background = "#081B0F";
            this.borderSty.border = "0.05rem solid #30A266";
             this.iconbgSty.background = "#30A266";
                this.shareBoxBg.backgroundColor="#081B0F",
                this.shareBoxBg.top="33.6rem",
            this.getXboxData();
        } else if (this.$route.query.type == "epic") {
            document.body.style.background = "#141414";
            this.getEpicData();
        }

       

        this.screeWidth = document.body.clientWidth;
        window.onresize = () => {
            
            return (() => {
                this.screeWidth = document.body.clientWidth;
            })();
        };

        // window.onload = function () {
		// 	document.getElementsByClassName("app-container")[0].style.opacity = '1' 
		// }

        GSAppJsApi.UI.registerNotificationListener("gamersky.app.shareButtonClicked", (e) => {
            
            GSAppJsApi.UMeng.recordEvent('share_annual_report', this.$route.query.type+'年报');
            GSAppJsApi.EventStatistics.recordEvent('B19108_分享年报用户数', this.$route.query.type+'年报' );
        });

        let that = this;

        window.addEventListener("setItemEvent",function(e){})//监听localStorage里的值变化


        window.addEventListener("scroll", e=>{
            that.scrollTop = e.target.scrollingElement.scrollTop;
        })
        window.addEventListener("touchstart", e=>{
            that.touchStart = e.targetTouches[0].pageY;
        })
        window.addEventListener("touchmove", e => {
            if (!that.sync && (e.targetTouches[0].pageY > that.touchStart && that.scrollTop == 0)){
                that.sync = true;
                that.swiper.slidePrev();
                setTimeout(() => {
                    that.sync = false;
                }, 1000);
            }
        })
        if (that.$route.query.type == "epic" && that.$route.query.shareRef && !GSAppJsApi.Environment.isInAppWebView()){
            that.$utils.SetHits(1554446, 'wap')
        }
        that.$utils.WeChatShare({
            title: "epic年报数据总结", // 分享标题
                desc: '点击查看"TA"的2024epic年报', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://imgs.gamersky.com/upimg/new_preview/2023/01/06/origin_202301061647408284.jpg', // 分享图标
        })
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    watch: {
        screeWidth: {
            handler(val) {
                this.index++;
               
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
       
        save() {
            let that=this
            document.getElementsByClassName('erweima')[0].style.opacity=1
            if(that.clickShareBtn){
                that.clickShareBtn=false
                setTimeout(function(){
                    
                    that.AddShareImg();
                },500)
                
            }
            
        },
        share(Original) {
            var shareInfo = GSAppJsApi.UI.createShareInfo("", Original, "", "", "", Original, function() {});
            GSAppJsApi.UI.share(shareInfo);
            this.clickShareBtn=true;
        },
        AddShareImg() {
            let that = this;
           
            // if (that.Original) {
            //     that.share(that.Original);
            //     return;
            // }
           
            var targetDom = document.getElementById("share");
            //  var num = IsMobile() ? 0 : ($('.ContentArea').offset().left + 10)
            html2canvas(targetDom, {
                height: targetDom.scrollHeight, //canvas高
                width: targetDom.scrollWidth, //canvas宽
                scale: 2, //按比例增加分辨率 (2=双倍).
                dpi: 100 // 处理模糊问题
                // x: num // 因为我的目标元素是水平居中的，所以通过这种方式来获取真实的偏移量
            }).then(function(canvas) {
                var url = canvas.toDataURL("image/jpeg", 1.0);

                $.ajax({
                    type: "post",
                    url: "https://instrument.gamersky.com/httphelper/UploadImageWithImageBase64Code",
                    data: {
                        ImageBase64Code: url
                    },
                    dataType: "json",
                    success: function(res) {
                        console.log(res);
                        //上传照片返回 线上地址 然后分享
                       
                        that.Original = res.Original;

                        that.share(that.Original);
                    }
                });
            });
        },
        epicShare(){
            let thumbnailUrl='https://imgs.gamersky.com/upimg/new_preview/2023/01/06/origin_202301061647408284.jpg'
            // let url='https://app.gamersky.com/zt/22annual/#/report?type=epic&id='+this.userId+'&appstatusbarstyle=kLightBar'
            let url='https://app.gamersky.com/zt/24annual/#/report?type=epic&id='+this.userId+'&appstatusbarstyle=kLightBar'
            // let url='https://project-test.gamersky.com/2023report/#/report?type=epic&id='+this.userId+'&appstatusbarstyle=kLightBar'
            console.log(url);
            var shareInfo = GSAppJsApi.UI.createShareInfo("renYi",thumbnailUrl, 'epic年报数据总结', '点击查看"TA"的2024epic年报', url, '', 0 , function() {});
            GSAppJsApi.UI.share(shareInfo);
           
        },
        epicDownBtn(){
            let url='https://app.gamersky.com/toapp/?url=https%3A%2F%2Fapp.gamersky.com%2Fzt%2F24annual%2F%23%2Fentrance%3Ftype%3Depic%26appstatusbarstyle%3DkLightBar%26appnavigationbarstyle%3Dknonebar&iOSUMKey=rKzC8j&androidUMKey=m4T1nm'
        
            window.location.href=url
             
        },

        getSteamData() {
            let data = {
                deviceType: "iPhone7,2",
                deviceId: "61BCED9D-EEE9-4F20-A197-5EF9BE079889",
                os: "iOS",
                osVersion: "12.5.5",
                app: "GSApp(iOS)",
                appVersion: "5.16.1",
                request: {
                    userId: this.$route.query.id==null?GSAppJsApi.User.getCurrentUserId():this.$route.query.id
                    // GSAppJsApi.User.getCurrentUserId()
                }
            };
            report.getSteamData(JSON.stringify(data)).then(res => {
                if (res.errorCode == 0) {
                    if (res.result.reportStatus == 1) {
                        this.data = res.result;
                        GSAppJsApi.UMeng.recordEvent('enter_steam_annual_report_success', 'steam年报-2024数据报告');
                        GSAppJsApi.EventStatistics.recordEvent('B19104_成功进入steam年报的用户数', 'steam年报-2024数据报告', 0);
                    } else if (res.result.reportStatus == 2) {
                        this.$router.push({
                            name: "percentage",
                            query: {
                                type: "steam"
                            }
                        });
                    } else if (res.result.reportStatus == 3) {
                        this.$router.push({
                            name: "waitingPage",
                            query: {
                                type: "steam"
                            }
                        });
                    }
                }
            });
        },
        getPsnData() {
            let data = {
                deviceType: "iPhone7,2",
                deviceId: "61BCED9D-EEE9-4F20-A197-5EF9BE079889",
                os: "iOS",
                osVersion: "12.5.5",
                app: "GSApp(iOS)",
                appVersion: "5.16.1",
                request: {
                    userId: this.$route.query.id==null?GSAppJsApi.User.getCurrentUserId():this.$route.query.id
                    // GSAppJsApi.User.getCurrentUserId()
                }
            };

            report.getPsnData(JSON.stringify(data)).then(res => {
                if (res.errorCode == 0) {
                    if (res.result.reportStatus == 1) {
                        this.data = res.result;
                         GSAppJsApi.UMeng.recordEvent('enter_psn_annual_report_success', 'psn年报-2024数据报告');
                        GSAppJsApi.EventStatistics.recordEvent('B19105_成功进入psn年报的用户数', 'psn年报-2024数据报告', 0);
                    } else if (res.result.reportStatus == 2) {
                        this.$router.push({
                            name: "percentage",
                            query: {
                                type: "psn"
                            }
                        });
                    } else if (res.result.reportStatus == 3) {
                        this.$router.push({
                            name: "waitingPage",
                            query: {
                                type: "psn"
                            }
                        });
                    }
                }
            });
        },
        getXboxData() {
            let data = {
                deviceType: "iPhone7,2",
                deviceId: "61BCED9D-EEE9-4F20-A197-5EF9BE079889",
                os: "iOS",
                osVersion: "12.5.5",
                app: "GSApp(iOS)",
                appVersion: "5.16.1",
                request: {
                    userId: this.$route.query.id==null?GSAppJsApi.User.getCurrentUserId():this.$route.query.id
                    // GSAppJsApi.User.getCurrentUserId()
                }
            };
            report.getXboxData(JSON.stringify(data)).then(res => {
                if (res.errorCode == 0) {
                    if (res.result.reportStatus == 1) {
                        this.data = res.result;
                        GSAppJsApi.UMeng.recordEvent('enter_xbox_annual_report_success', 'xbox年报-2024数据报告');
                        GSAppJsApi.EventStatistics.recordEvent('B19106_成功进入xbox年报的用户数', 'xbox年报-2024数据报告', 0);
                    } else if (res.result.reportStatus == 2) {
                        this.$router.push({
                            name: "percentage",
                            query: {
                                type: "xbox"
                            }
                        });
                    } else if (res.result.reportStatus == 3) {
                        this.$router.push({
                            name: "waitingPage",
                            query: {
                                type: "xbox"
                            }
                        });
                    }
                }
            });
        },
        getEpicData() {
            // GSAppJsApi.User.getCurrentUserId()
            if (this.$route.query.shareRef && GSAppJsApi.Environment.isInAppWebView()){
                GSAppJsApi.User.loginTo();
            } else {
                this.userId=this.$route.query.id==null?GSAppJsApi.User.getCurrentUserId():this.$route.query.id

                this.$ajax.get("//router.gamersky.com/@/epic/reportData/"+ this.userId).then(res => {
             
                    if (res.data.reportStatus == 1) {
                        this.data = res.data;
                        GSAppJsApi.UMeng.recordEvent('enter_epic_annual_report_success', 'epic年报-2024数据报告');
                        GSAppJsApi.EventStatistics.recordEvent('B19107_成功进入epic年报的用户数', 'epic年报-2024数据报告', 0);
                    } else if (res.data.reportStatus == 2) {
                        this.$router.push({
                            name: "percentage",
                            query: {
                                type: "epic"
                            }
                        });
                    } else if (res.data.reportStatus == 3) {
                        this.$router.push({
                            name: "waitingPage",
                            query: {
                                type: "epic"
                            }
                        });
                    }
                });
            }
            
        }
    },
    components: {
        index,
        gameTime,
        gamePrice,
        likeGame,
        highScoreGame,
        playLateGame,
        differentGame,
        dearGame,
        hotGame,
        longTimeGame,
        share,
        waitingPage,
        percentage,
        gameList,
        swiper,
        swiperSlide,

        footerPage ,
        footerBg,
        headerBg
    }
};
</script>

<style lang="scss">

.app-container {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.swiper {
    // height: 100vh;
    // height: 42.2rem;
    overflow: hidden;
    .swiper-slide {
        // height: 100vh ;
    }
}
.swiper-wrapper{
    height: 42.2rem;
}
.footerPage {
    position: fixed;
    // bottom: 1rem;
    top: 40rem;
    left: 1.75rem;
}
.footerBg {
    position: fixed;
    left: 0;
    right: 0;
}
.epicShareBtn {
    width: 100%;
    background-color: #222;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    display: none;
    padding-bottom: 2.1rem;
    padding-top: 0.5rem;
}
.epicShareBtn div {
    width: 14.9rem;
    height: 1.75rem;
    margin: 0 auto;
    border-radius: 0.85rem;
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 1.75rem;
    text-align: center;
    background: linear-gradient(90deg, #ff7777, #ed4343);
}

.app-container .btn {
    display: flex;
    // justify-content: space-between;
    justify-content: center;
    // padding: 0 2.6rem;
    position: absolute;
   
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    height: 5.5rem;
    box-sizing: border-box;
    z-index: 9;
}
.app-container .btn > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.app-container .btn > div:first-child{
    margin-right: 4.85rem;
}

.app-container .btn .icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    margin-bottom: 0.65rem;
    padding: 0.15rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.app-container .btn .icon img {
    width: 1.1rem;
    height: 1.1rem;
    display: block;
}
.app-container .btn .icon > div {
    width: 2.45rem;
    height: 2.45rem;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.btn .btnTxt {
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
